<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
            d="M13.7151 8C14.1932 8.24798 14.601 8.61261 14.9006 9.0601C15.2003 9.50761 15.3822 10.0235 15.4294 10.56C15.4294 12.7657 12.1037 14.56 8.00084 14.56C3.89798 14.56 0.572266 12.7771 0.572266 10.5714C0.617636 10.0329 0.798644 9.5147 1.09841 9.06505C1.39817 8.61541 1.80693 8.24899 2.28655 8"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M4.66374 2.57178C2.37802 5.42892 6.94945 6.57178 4.66374 9.42892"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8.00163 1.42871C5.71591 4.28585 10.2873 7.71443 8.00163 10.5716"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M11.3376 2.57178C9.05185 5.42892 13.6233 6.57178 11.3376 9.42892"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
